import './slim.min.css';

/*
 * Slim v4.10.0 - Image Cropping Made Easy
 * Copyright (c) 2017 Rik Schennink - http://slimimagecropper.com
 */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// Slim (place slim CSS and module js file in same folder as this file)
import Slim from './slim.module.js';

export default class extends React.Component {
  static propTypes = {
    initialImage: PropTypes.string,
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    const root = ReactDOM.findDOMNode(this);
    const { initialImage } = this.props;

    if (initialImage) {
      const img = document.createElement('img');
      img.setAttribute('alt', '');
      img.setAttribute('src', initialImage);
      root.appendChild(img);
    }

    this.instance = Slim ? Slim.create(root, this.props) : null;
  }

  render() {
    return <div className="slim">{this.props.children}</div>;
  }
}
